export default {
    get (key) {
        try {
            return JSON.parse(localStorage.getItem(key))
        } catch (e) {}
    },

    set (key, value) {
        try {
            localStorage.setItem(key, JSON.stringify(value))
        } catch (e) {}
    },

    remove (key) {
        try {
            localStorage.removeItem(key)
        } catch (e) {}
    },

    clear () {
        try {
            localStorage.clear()
        } catch (e) {}
    }
}


// WEBPACK FOOTER //
// ./src/core/storage.js